import React, { Component } from "react";
import platform from "Pub/js/platform";
import "./menu.less";
const { NCDiv } = platform.base;
const IconMap = {
    '01': "gxh-morenshezhi", //默认设置
    '02': "changyongshuju", //常用数据
    '03': "dailirenshezhi", //代理人设置
    // '04': "gxh-yonghujiemianshezhi", //用户界面设置
    'BCS': "jituancaiwuhebing", //集团财务合并
    'BGR': "jituancaiwubaobiao", //集团报表
    'PM': "gxh-xiangmuguanli", //项目管理
    'TB': "quanmianyusuan", //全面预算
};
class MenuListItem extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return <li {...this.props}>{this.props.children}</li>;
    }
}
class MenuList extends Component {
    constructor(props) {
        super(props);
    }
    getIconClass = item => {
        return IconMap[item.code] || "jituancaiwuhebing";
    };
    createList = listArray =>
        listArray.map(item => {
            const iconClass = this.getIconClass(item);
            return (
                <MenuListItem
                    className={`side-menu-li ${item.active ? "side-menu-active" : ""}`}
                    key={item.url}
                    onClick={() => {
                        this.props.onClick(item.url);
                    }}
                >
                    <i className={`iconfont icon-${iconClass}`} style={{ fontSize: 16, marginRight: 10 }}/>
                    {item.name}
                </MenuListItem>
            );
        });
    render() {
        return (
            <NCDiv className='side-menu-ul' fieldid='nav' areaCode={NCDiv.config.Area}>
                {this.createList(this.props.listArray)}
            </NCDiv>
        );
    }
}
export default MenuList;
